import core from "./chat.core";
const chat = Object.assign({}, core);
Object.freeze(chat);
export default chat;
